import { render, staticRenderFns } from "./SidebarMinimizer.vue?vue&type=template&id=c9d35542"
import script from "./SidebarMinimizer.vue?vue&type=script&lang=js"
export * from "./SidebarMinimizer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports